import { render } from "./VLotInfoHead.vue?vue&type=template&id=b5f467ee&scoped=true"
import script from "./VLotInfoHead.vue?vue&type=script&lang=js"
export * from "./VLotInfoHead.vue?vue&type=script&lang=js"

import "./VLotInfoHead.vue?vue&type=style&index=0&id=b5f467ee&lang=scss&scoped=true"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f467ee"]])

export default __exports__